module.exports = __webpack_public_path__ + "media/notification-error.dfc8bd25.mp3";